import { faMoneyCheck, faUniversity } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Badge, Button, Card, Col, Row } from 'react-bootstrap';

import es from '../../lang/es';
import alertMessages from '../../helpers/alertMessages';
import { useDispatch } from 'react-redux';

import { branchPaymentLotAction } from '../../actions/paymentLotsActions';
import colors from '../../constants/colors';
import { useNavigate } from 'react-router';
import routes from '../../constants/routes';
import PaymentLot from './PaymentLot';

const PaymentLotList = ({paymentLots}) => {
    //Dispatch
    const dispatch = useDispatch();
    //Navigate
    let navigate = useNavigate();
    //Manejo el pago sucursal
    const handleBranchPayment = (e, lot) => {
        e.preventDefault();
        //Seteo los datos
        const data = {
            title: es.CONFIRMATION.BRANCH_PAYMENT,
            text: es.CONFIRMATION.PAYMENT,
            confirmText: es.PAYMENTS.BRANCH,
            confirmColor: colors.blue,
            callback: () => {
                //Ejecuto
                dispatch( branchPaymentLotAction(lot) );
            }
        }
        //Confirmación
        alertMessages.confirm(data);
    }
    //Manejo el pago online
    const handleOnlinePayment = (e, lot) => {
        e.preventDefault();
        //Seteo los datos
        const data = {
            title: es.CONFIRMATION.ONLINE_PAYMENT,
            text: es.CONFIRMATION.PAYMENT,
            confirmText: es.PAYMENTS.ONLINE,
            confirmColor: colors.green,
            callback: () => {
                //Redirecciono
                navigate(routes.PAYMENT_CHECKOUT_ONLINE(lot.id));
            }
        }
        //Confirmación
        alertMessages.confirm(data);
    }
    //Render
    return (
        paymentLots.map((paymentLot, index) => (
            <Col xs={12} key={`pl${paymentLot.id}`}>
                <Card className="mb-3">
                    <Card.Header className='bg-dark'>
                        <Badge variant='light' pill>
                            { es.LOT } #{index + 1}
                        </Badge>
                        <strong className='ml-2 text-white'>{ paymentLot.identificator }</strong>
                    </Card.Header>
                    <PaymentLot
                        paymentLot={paymentLot}
                    />
                    <Card.Footer>
                        <Row>
                            <Col md={6} xs={12} className='text-center text-md-left mb-3 mb-md-0'>
                                <span className="h4">
                                    { es.PAYMENTS.TOTAL.toUpperCase() }: { es.PAYMENTS.CURRENCY }<strong>{ paymentLot.total }</strong>
                                </span>
                            </Col>
                            <Col md={6} xs={12} className='text-center text-md-right'>
                            {
                                paymentLot.online_payment ? (
                                    <Button 
                                        variant="success" 
                                        className="mr-2" 
                                        onClick={e => handleOnlinePayment(e, paymentLot)}
                                        size="sm"
                                    >
                                        <FontAwesomeIcon icon={faMoneyCheck} /> <strong>{ es.PAYMENTS.ONLINE.toUpperCase() }</strong>
                                    </Button>
                                ) : null
                            }
                            {
                                paymentLot.branch_payment ? (
                                    <Button 
                                        variant="primary" 
                                        onClick={e => handleBranchPayment(e, paymentLot)}
                                        size="sm"
                                    >
                                        <FontAwesomeIcon icon={faUniversity} /> <strong>{ es.PAYMENTS.BRANCH.toUpperCase() }</strong>
                                    </Button>
                                ) : null
                            }
                            </Col>
                        </Row>
                    </Card.Footer>
                </Card>
            </Col>
        ))
    );
};

export default PaymentLotList;